export class OrderAction {
  static readonly type = '[Order] Add item';
  constructor(public payload: string) { }
}

export class LoadAllOrders {
  static readonly type = '[Order] Load All';
  constructor() { }
}

export class LoadOrder {
  static readonly type = '[Order] Load Order';
  constructor(public id: string) { }
}

export class RefreshOrder {
  static readonly type = '[Order] Refresh Order';
  constructor() { }
}

